/**
 * Convert \\ into <br>.
 */
export default (value: string) => value.split('\\').join('<br>')
